import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import { mapGetters } from "vuex";
import telematicsService from "../../../api/telematics.service";
export default {
  name: "groups",
  components: {
    pageheader,
  },
  data() {
    return {
      search: "",
      options: {},
      loading: false,
      delName: "",
      deleteId: "",
      isdelete: false,
      input: {},
      dialog: false,
      headers: [
        { text: "Type", value: "type" },
        { text: "Group Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "Equipment", value: "machines" },
        { text: "Action", value: "action" },
      ],
      activeGroups: [],
      isFilter: false,
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  mounted() {
    this.input = utils.getInputContent("groups", this.roles);
    if (this.$route.query && this.$route.query.isFilter) {
      this.search = this.$route.query.filterVal;
      this.isFilter = this.$route.query.isFilter;
    }
    this.getGroups();
  },
  methods: {
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.activeGroups = response.data;
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    confirmDelete(item) {
      this.deleteId = item.id;
      this.delName = item.name;
      this.dialog = true;
    },
    async deletGroup() {
      try {
        this.isdelete = true;
        let delUser = await telematicsService.removeGroup(this.deleteId);
        if (delUser) {
          this.isdelete = false;
          this.$toast.success(delUser.systemMessage);
          this.getGroups();
          this.dialog = false;
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete user" + err);
        this.dialog = false;
      }
    },
    editGroup(item) {
      this.$router.push({
        name: "editGroup",
        params: { id: item.id },
        query: {
          filterVal: this.isFilter ? this.search : "",
          isFilter: this.isFilter,
        },
      });
    },
    onSearch() {
      if (this.search) {
        this.isFilter = true;
      } else {
        this.isFilter = false;
      }
    },
    clearSearch() {
      this.search = "";
      this.$router.replace(`/groups-management/list`);
      this.getGroups();
    },
  },
};
